export const EFFORT_MINUTES: Record<string, number> = { low: 30, medium: 60, high: 120 }

type Timed = { minutes?: number | null; durationMinutes?: number | null; effort?: string | null }

// A task's real length when it has one (plan estimate or its own duration), else
// null — older plans only carry an effort level.
export function exactTaskMinutes(task: Timed): number | null {
  return task.minutes ?? task.durationMinutes ?? null
}

export function formatMinutes(min: number): string {
  if (min < 60) return `${min}m`
  const h = Math.floor(min / 60)
  const m = min % 60
  return m ? `${h}h ${m}m` : `${h}h`
}

// "25m" from real minutes; "~1h" estimated from effort for tasks without them.
export function taskTimeLabel(task: Timed, approxMark = '~'): string {
  const exact = exactTaskMinutes(task)
  if (exact) return formatMinutes(exact)
  return `${approxMark}${formatMinutes(EFFORT_MINUTES[task.effort ?? ''] ?? 60)}`
}
